<template lang="html">
  <div class="NameCard">


    <header class="navbar">
    <section class="navbar-primary">
      <a href="#" class="navbar-brand mr-10">Back</a>
    </section>

    <section class="navbar-section">
      <div class="input-group input-inline">

        <!-- <button class="btn btn input-group-btn">...</button> -->
      </div>
    </section>
  </header>

  <div class="panel">
    <div class="container" v-for="name in names" >
      <div class="columns col-oneline">
        <div class="column col-4">
          <p class="float-left">
          {{ name.value }}<span v-if="name.favorite">*</span></p>

        </div>
        <div class="column col-6">
          Total: <b>{{ endRating(name.rating) }}</b> <br>
          Avg: {{ average(name.rating) }} - Count: {{ ratingCount(name.rating) }}
          <!-- <div class="bar bar-sm">
            <div class="bar-item" role="progressbar" style="width:25%;" :aria-valuenow="barRating(name.rating)" aria-valuemin="0" aria-valuemax="100"></div>
          </div> -->
          <!-- <meter class="meter" :value="barRating(name.rating)" min="0" max="100" low="40" high="80"></meter> -->
        </div>
        <div class="column col-2">
          <button class="btn btn-link" @click="deleteRecommendation(name['.key'])">Delete</button>
        </div>
      </div>
    </div>




  </div>
</div>
</template>

<script>
import { db } from '../firebase'
const names = db().ref('names')
import Names from '../models/names'
const namesModel = Names({namesDb: names})
import { values } from 'lodash'

import { User, ratingAverage, ratingOn100Scale } from '@/helper/helper'

const filterUserRecommendations = user => name => name.recommended === user

const sort = {
  asc: names => names.sort((a, b ) => ratingAverage(a.rating) - ratingAverage(b.rating))
}

const addStat = name => Object.assign({}, name, {
  stat: {
    average: ratingAverage(rating).toFixed(2),
    count: values(rating).length,
    endResult: ratingCount(rating) * average(rating),
  },
})

const namesWithStat = namesRef => {
  if (typeof namesRef === 'undefined') {
    return []
  }
  return namesRef.map(addStat)
}

export default {
  name: 'ListUserRecommendations',
  data: {
    sortOrder: 'asc',
    names: []
  },
  computed: {
    // nameStats: namesWithStat(this.names)
  },
  methods: {
    deleteRecommendation: function(nameKey) {
      return namesModel.removeName(nameKey, User().get())
    },
    average: function(rating) {
      return ratingAverage(rating).toFixed(2)
    },
    ratingCount: function(rating) {
      return values(rating).length
    },
    endRating: function(rating){
      return this.ratingCount(rating) * this.average(rating)
    },
    barRating: function(rating) {
      return ratingOn100Scale(ratingAverage(rating))
    }
  },
  firebase: {
    names: names
  },
}
</script>

<style lang="css" scoped>
.bar {
  margin-top: 10px
}

.navbar{
  height: 1.4em;
}
</style>



// WEBPACK FOOTER //
// ListUserRecommendations.vue?2e819dcd